import type { Middleware } from "@reduxjs/toolkit";

import { setEditMode } from "@/features/app/appSlice";
import {
  setPathsEditorSelectedFeatureId,
  setSelectedFeatureId,
} from "@/features/editor/editorSlice";

/**
 * When changing edit mode, make sure to cleanup selected features
 */
const cleanupSelectedFeaturesMiddleware: Middleware =
  (store) => (next) => (action) => {
    if (setEditMode.match(action)) {
      store.dispatch(setPathsEditorSelectedFeatureId(null));
      store.dispatch(setSelectedFeatureId(null));
    }

    return next(action);
  };
export default cleanupSelectedFeaturesMiddleware;
